import { render, staticRenderFns } from "./CustomerLegal.vue?vue&type=template&id=580418f5"
import script from "./CustomerLegal.vue?vue&type=script&lang=js"
export * from "./CustomerLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports